export default __webpack_public_path__ + "static/media/outlook.com.73d6f708.svg";